export default __webpack_public_path__ + "static/media/main-logo.250ebab2.svg";